// extracted by mini-css-extract-plugin
export default {"root":"ConfirmEmail_root__CuCYv","container":"ConfirmEmail_container__1tfHl","footer":"ConfirmEmail_footer__3UwMf"};